import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=98060422&scoped=true"
import script from "./Node.vue?vue&type=script&lang=js"
export * from "./Node.vue?vue&type=script&lang=js"
import style0 from "./Node.vue?vue&type=style&index=0&id=98060422&prod&scoped=true&lang=css"
import style1 from "./Node.vue?vue&type=style&index=1&id=98060422&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98060422",
  null
  
)

export default component.exports